import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import _ from 'lodash';
import { sendGetRequest } from '../services/PDService';
import * as Sentry from '@sentry/browser';

export const getActions = createAsyncThunk(
  'action/getActions',
  async (payload, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await sendGetRequest(
        'actions?vhId=' + (payload ?? -1) + '&nestChildItems=true',
        getState().virtualHuman.data.ShareToken
      );
      return response.data.data.actions;
    } catch (err) {
      Sentry.captureException(err);
      return rejectWithValue(err.response.data);
    }
  }
);

export const getActionGroups = createAsyncThunk(
  'action/getActionGroups',
  async (payload, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await sendGetRequest(
        'action-groups?vhId=' + (payload ?? -1),
        getState().virtualHuman.data.ShareToken
      );
      return response.data.data.actionGroups;
    } catch (err) {
      Sentry.captureException(err);
      return rejectWithValue(err?.response?.data);
    }
  }
);

const ActionSlice = createSlice({
  name: 'action',
  initialState: {
    status: 'idle',
    groups: null,
    actions: null,
    error: '',
  },
  reducers: {
    resetActions: (state, action) => {
      state.actions = null;
      state.groups = null;
    },
  },
  extraReducers: {
    [getActionGroups.pending]: (state, action) => {
      state.status = 'pending';
    },
    [getActionGroups.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.groups = action.payload;
    },
    [getActionGroups.rejected]: (state, action) => {
      state.status = 'rejected';
      state.error = 'Failed to connect.';
    },
    [getActions.pending]: (state, action) => {
      state.status = 'pending';
    },
    [getActions.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.actions = action.payload;
    },
    [getActions.rejected]: (state, action) => {
      state.status = 'rejected';
      state.error = 'Failed to connect.';
    },
  },
});

// Destructure and export the plain action creators
export const { resetActions } = ActionSlice.actions;

export const actionsSelector = (state) => state.action.actions ?? [];
export const actionGroupsSelector = (state) => state.action.groups ?? [];

export default ActionSlice;
